import styled from '@emotion/styled';

import { MainContent, Title } from '../../../components/Card/ReviewCard';
import Img from '../../../components/Img/Img';

const PasswordReset = () => {
  return (
    <>
      <OtpContent>
        <StyleImg src="/static/img/suss.png" />
        <Title1>
          <Title>Password Reset Link Sent</Title>
        </Title1>
        <MainContent1>
          <MainContent>
            A password reset link has been successfully sent to your email
            address.
          </MainContent>
        </MainContent1>
      </OtpContent>
    </>
  );
};

export default PasswordReset;

const StyleImg = styled(Img)`
  max-width: 5rem;
`;

const OtpContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1px;
  padding: 0.5rem 2rem 0.2rem 2rem;
  width: 600px;
  align-items: center;
  background-color: white;
  box-shadow: 0 7px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    box-shadow: none;
  }
`;

const Title1 = styled.h2`
  margin-bottom: 20px;
  font-size: 24px;
`;

const MainContent1 = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey1};
  margin-bottom: 1.5rem;
  text-align: center;
  width: 60%;
`;
